/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    var module = this;

    module.sliderSettingsObject = {
        global: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: 3,
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500
        },

        partners: {
            slidesPerView: "auto",
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            speed: 500,
            on: {
                reachBeginning: function () {
                    const swiper = this;
                    const el = swiper.el;
                    const elParent = el.closest(".js-slider");
                    elParent.classList.remove("is-ended");
                },

                reachEnd: function () {
                    const swiper = this;
                    const el = swiper.el;
                    const elParent = el.closest(".js-slider");
                    elParent.classList.add("is-ended");
                }
            }
        },

        docs: {
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            speed: 500,
            on: {
                reachBeginning: function () {
                    const swiper = this;
                    const el = swiper.el;
                    const elParent = el.closest(".js-slider");
                    elParent.classList.remove("is-ended");
                },

                reachEnd: function () {
                    const swiper = this;
                    const el = swiper.el;
                    const elParent = el.closest(".js-slider");
                    elParent.classList.add("is-ended");
                }
            }
        },

        gallery: { /* Галерея внутри модалки */
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            slidesPerView: "auto",
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            on: {
                init: function () {
                    var swiper = this;
                    console.log(swiper.el.id)
                    itsoftApp.modules.slidersLibrary.sliders[swiper.el.id] = swiper;
                }
            },
            speed: 500
        }
    };
});